import React from 'react';
import { Box, Typography } from '@mui/material';
import { DragIndicator as DragIndicatorIcon } from '@mui/icons-material';

interface MoodDragOverlayProps {
  name: string | null;
}

const MoodDragOverlay: React.FC<MoodDragOverlayProps> = ({ name }) => {
  if (!name) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 2,
        py: 1.5,
        bgcolor: '#fff',
        borderRadius: '10px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
        border: '2px solid #1A5F7A',
        minWidth: 180,
        maxWidth: 280,
      }}
    >
      <DragIndicatorIcon sx={{ fontSize: 18, color: '#94a3b8' }} />
      <Typography
        sx={{
          fontFamily: '"Montserrat", sans-serif',
          fontWeight: 700,
          fontSize: '0.82rem',
          color: '#1e293b',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {name}
      </Typography>
    </Box>
  );
};

export default MoodDragOverlay;
